import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        padding: theme.spacing(2, 0, 0)
    },
    settingRow: {
        display: 'flex',
        marginBottom: theme.spacing(1.8),
        justifyContent: 'space-between'
    },
    label: {
        width: '30%',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        justifyContent: 'left'
    },
    value: {
        textAlign: 'left',
        width: '65%',
        fontSize: '14px',
        fontWeight: 'normal',
        textTransform: 'capitalize',
        display: 'flex',
        justifyContent: 'left'
    },
    textArea: {
        width: '100%'
    }
}))

export default useStyles